export const TRADE_HISTORY_TABS = {
  orderHistory: {
    key: "orderHistory",
    name: "Order History",
    value: 0,
  },

  tradeHistory: {
    key: "tradeHistory",
    name: "Trade History",
    value: 1,
  },
};

export const TRADE_HISTORY_TABLE_HEADERS = [
  {
    key: "side",
    name: "Side",
    align: "left",
  },
  {
    key: "userRegister",
    name: "Username",
    align: "left",
  },
  {
    key: "broker",
    name: "Broker",
    align: "center",
  },
  {
    key: "basketOwner",
    name: "Basket",
    align: "center",
  },
  {
    key: "type",
    name: "Type",
    align: "center",
  },
  {
    key: "market",
    name: "Market",
    align: "center",
  },
  {
    key: "filled",
    name: "Amount",
    align: "center",
  },
  {
    key: "price",
    name: "Price",
    align: "center",
  },
  {
    key: "fee",
    name: "Fee",
    align: "center",
  },
  {
    key: "total",
    name: "Total",
    align: "center",
  },
  {
    key: "date",
    name: "Date",
    align: "center",
  },
  {
    key: "state",
    name: "State",
    align: "center",
  },
];

export const TRADE_HISTORY_TABLE_HEADERS_ORDER = [
  {
    key: "side",
    name: "Side",
    align: "left",
  },
  {
    key: "userRegister",
    name: "Username",
    align: "left",
  },
  {
    key: "broker",
    name: "Broker",
    align: "center",
  },
  {
    key: "basketOwner",
    name: "Basket",
    align: "center",
  },
  {
    key: "type",
    name: "Type",
    align: "center",
  },
  {
    key: "market",
    name: "Market",
    align: "center",
  },
  {
    key: "filled",
    name: "Amount",
    align: "center",
  },
  {
    key: "price",
    name: "Price",
    align: "center",
  },
  {
    key: "total",
    name: "Total",
    align: "center",
  },
  {
    key: "date",
    name: "Date",
    align: "center",
  },
  {
    key: "state",
    name: "State",
    align: "center",
  },
  {
    key: "action",
    name: "",
    align: "center",
  },
];
